import React, { useEffect } from 'react';
import { CloseIcon } from './icons';

export default function Modal({ title, eyebrow, onClose, children, actions, size = '' }) {
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="dp-modal-root" role="presentation">
      <div className="dp-modal-backdrop" onClick={onClose} aria-hidden />
      <div className={`dp-modal ${size ? `dp-modal--${size}` : ''}`} role="dialog" aria-modal="true" aria-label={title}>
        <div className="dp-modal-head">
          <div>
            {eyebrow ? <p className="dp-eyebrow">{eyebrow}</p> : null}
            <h3>{title}</h3>
          </div>
          <button type="button" className="dp-icon-btn" onClick={onClose} aria-label="Close">
            <CloseIcon />
          </button>
        </div>
        <div className="dp-modal-body">{children}</div>
        {actions ? <div className="dp-modal-actions">{actions}</div> : null}
      </div>
    </div>
  );
}
